package hk.com.vr360_demo2.webapp.component.viewer.component

import hk.com.vr360_demo2.webapp.Colors
import hk.com.vr360_demo2.webapp.component.dialog.BaseDialog
import hk.com.vr360_demo2.webapp.component.dialog.DialogContentText
import react.FC
import react.Props
import react.create

external interface DisclaimerDialogProps : Props {
    var show: Boolean
    var onClose: () -> Unit
}

val DisclaimerDialog = FC<DisclaimerDialogProps> { props ->
    BaseDialog {
        show = props.show
        title = "免責聲明"
        onClose = props.onClose
        content = DialogContentText.create {
            text = """1.本 360° 全景，僅作現場參考，不構成任何要約或保證。
2.物業面積、間隔、產權、設施等資料，均以業主提供文件及現場實際情況為準。
3.全景因拍攝角度、光線等因素，或與現場存在視覺差異，請以實地視察為準。
4.室內傢俬、電器、裝修等以交易當下狀態為主，本公司及經紀人不作保留承諾。
5.使用者因依賴本全景內容所引致的一切損失，本公司及經紀人概不承擔法律責任。
6.未經書面授權，不得轉載、修改或商用本360°全景。"""
        }
    }
}
